module.exports = __webpack_public_path__ + "img/img.288e739f.jpg";